import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="inline-block text-2xl font-heading font-bold text-foreground-950 mb-4"
            >
              17<span className="text-primary-500">c</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              探索17c的全部可能 — 您不可错过的核心体验平台。一站式数字体验，赋能个人与团队。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="/category/getting-started" className="hover:text-primary-500 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#" className="hover:text-primary-500 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">关于我们</Link>
              </li>
              <li>
                <Link to="/category/getting-started" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">入门指南</Link>
              </li>
              <li>
                <Link to="/category/faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">常见问题</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="/about" className="hover:text-primary-500 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center" />
                <span>support@17c.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500 w-4 h-4 flex items-center justify-center" />
                <span>400-888-17C1</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500 w-4 h-4 flex items-center justify-center" />
                <span>北京市朝阳区科技园区17号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 17c. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-500 transition-colors">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}